export const lang = {
  "en": "อังกฤษ",
  "th": "ไทย"
};
